import React from "react";
import RegisterPage, { StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { apiFetch } from "../lib/api";

export default function EmergencyPreparedness() {
  const { data, siteNames } = useHSE();
  const rows = data.drills || [];
  const byType = (t) => rows.filter((r) => r.drillType === t || r.type === t).length;

  const handleSaveRecord = async (editingRecord) => {
    try {
      const res = await apiFetch("/emergency-drills", {
        method: "POST",
        body: {
          ...editingRecord,
          idempotencyKey: `emg-${editingRecord.id}`,
        },
      });
      return res?.item ? { ...editingRecord, ...res.item } : editingRecord;
    } catch (err) {
      return editingRecord;
    }
  };

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      <StatCard label="Drills YTD" value={rows.length} testid="drl-total" />
      <StatCard label="Fire Drills" value={byType("fire") + byType("Fire Drill")} tone="warning" testid="drl-fire" />
      <StatCard label="Evacuation" value={byType("chemical_spill") + byType("Evacuation")} tone="info" testid="drl-evac" />
      <StatCard label="Medical" value={byType("medical_evacuation") + byType("Medical Emergency")} tone="critical" testid="drl-med" />
      <StatCard label="Confined Rescue" value={byType("confined_space_rescue") + byType("Confined Space Rescue")} tone="safe" testid="drl-cs" />
    </div>
  );

  return (
    <RegisterPage
      title="Emergency Preparedness & Drill Register"
      subtitle="Fire, evacuation, rescue, chemical spill and medical emergency drills — ISO 45001 §8.2"
      storeKey="drills"
      idPrefix="EMG"
      topPanels={Top}
      onSaveRecord={handleSaveRecord}
      columns={[
        { key: "id", label: "Drill ID" },
        { key: "scheduledDate", label: "Scheduled Date" },
        { key: "site", label: "Site" },
        { key: "drillType", label: "Drill Type", render: (r) => <span className="font-semibold">{r.drillType || r.type}</span> },
        { key: "drillScenario", label: "Scenario" },
        { key: "evaluationScore", label: "Score", render: (r) => <span className={`font-mono font-bold ${Number(r.evaluationScore) < 70 ? "text-rose-600 font-extrabold" : "text-emerald-700"}`}>{r.evaluationScore ? `${r.evaluationScore}%` : "Pending"}</span> },
        { key: "headcountReconciliation", label: "Headcount", render: (r) => <span className={`uppercase text-[10px] font-bold px-2 py-0.5 rounded ${r.headcountReconciliation === "fail" ? "bg-rose-100 text-rose-800" : "bg-emerald-100 text-emerald-800"}`}>{r.headcountReconciliation || "pass"}</span> },
        { key: "actionId", label: "Linked CAPA", render: (r) => r.actionId ? <span className="font-mono text-[11px] text-[#18B84F]">{r.actionId}</span> : <span className="text-slate-300">—</span> },
      ]}
      formFields={[
        { key: "id", label: "Drill ID" },
        { key: "scheduledDate", label: "Scheduled Date", type: "date" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "drillType", label: "Drill Type", type: "select", options: ["fire", "chemical_spill", "confined_space_rescue", "medical_evacuation", "severe_weather"] },
        { key: "drillScenario", label: "Drill Scenario", type: "textarea", full: true },
        { key: "evacuationTimeSeconds", label: "Evacuation Time (Seconds)", type: "number" },
        { key: "evaluationScore", label: "Evaluation Score (0-100)", type: "number" },
        { key: "headcountReconciliation", label: "Headcount Reconciliation", type: "select", options: ["pass", "fail", "partial"] },
        { key: "status", label: "Status", type: "select", options: ["scheduled", "completed", "cancelled"] },
      ]}
    />
  );
}
